module.exports = __webpack_public_path__ + "img/cancel.464102f3.png";